import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=485518fb&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
import style0 from "./Config.vue?vue&type=style&index=0&id=485518fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_65uhlok3ryww266g2rjqqwj3cm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485518fb",
  null
  
)

export default component.exports